<div class="cv-review">
  <header class="cv-review__intro">
    <div>
      <h1>{{ "cv-review.title" | translate }}</h1>
      <p>{{ "cv-review.description" | translate }}</p>
    </div>
    <span class="cv-review__status">{{ "cv-review.status.ai-extracted" | translate }}</span>
  </header>
  <section class="cv-review__progress">
    <div class="cv-review__progress-label">
      <strong>{{ "cv-review.progress.label" | translate }}</strong>
      <span>{{ "cv-review.progress.complete" | translate : { percentage: progressPercentage } }}</span>
    </div>
    <div class="cv-review__progress-track"><span [style.width.%]="progressPercentage"></span></div>
  </section>
  <form nz-form nzLayout="vertical" class="cv-review__form">
    <section class="cv-card">
      <div class="cv-card__header">
        <div>
          <h2>{{ "cv-review.experience.title" | translate }}</h2>
          <p>{{ "cv-review.experience.description" | translate }}</p>
        </div>
        <span class="cv-card__count">{{ "cv-review.status.parsed" | translate }}</span>
      </div>
      <div class="cv-card__body">
        <nz-form-item>
          <nz-form-label>{{ "cv-review.experience.years" | translate }}</nz-form-label>
          <nz-form-control>
            <input nz-input type="number" [(ngModel)]="yearsOfExperience" name="yearsOfExperience" />
          </nz-form-control>
        </nz-form-item>
      </div>
    </section>
    <section #trackRecordSection class="cv-card cv-card--compact">
      <div class="cv-card__header">
        <div>
          <h2>{{ "cv-review.track-record.title" | translate }}</h2>
          <p>{{ "cv-review.track-record.description" | translate }}</p>
        </div>
        <span class="cv-card__count">{{ "cv-review.entries" | translate : { count: mappedTrackRecords.length } }}</span>
      </div>
      <div class="cv-card__body">
        <div *ngIf="trackRecordValidationError" class="cv-review__validation-warning" role="alert">
          <span nz-icon nzType="exclamation-circle" nzTheme="fill"></span>
          <span>{{ trackRecordValidationError }}</span>
        </div>
        <ng-container *ngIf="parsedCvReady; else parsedCvLoading">
          <mh-track-records-input [value]="mappedTrackRecords" [showAddBtn]="false"></mh-track-records-input>
        </ng-container>
      </div>
    </section>
    <section #educationSection class="cv-card cv-card--compact">
      <div class="cv-card__header">
        <div>
          <h2>{{ "cv-review.education.title" | translate }}</h2>
          <p>{{ "cv-review.education.description" | translate }}</p>
        </div>
        <span class="cv-card__count">{{ "cv-review.entries" | translate : { count: mappedEducations.length } }}</span>
      </div>
      <div class="cv-card__body">
        <div *ngIf="educationValidationError" class="cv-review__validation-warning" role="alert">
          <span nz-icon nzType="exclamation-circle" nzTheme="fill"></span>
          <span>{{ educationValidationError }}</span>
        </div>
        <ng-container *ngIf="parsedCvReady; else parsedCvLoading">
          <mh-educations-input [value]="mappedEducations" [showAddBtn]="false"></mh-educations-input>
        </ng-container>
      </div>
    </section>
    <section class="cv-card">
      <div class="cv-card__header">
        <div>
          <h2>{{ "cv-review.qualifications.title" | translate }}</h2>
          <p>{{ "cv-review.qualifications.description" | translate }}</p>
        </div>
      </div>
      <div class="cv-card__body">
        <nz-form-item>
          <nz-form-label>{{ "cv-review.qualifications.label" | translate }}</nz-form-label>
          <nz-form-control>
            <nz-select nzMode="tags" [(ngModel)]="certifications" name="certifications"></nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </section>
  </form>
</div>
<ng-template #parsedCvLoading><span class="cv-review__loading"><nz-spin nzSimple></nz-spin></span></ng-template>
<ng-container *nzModalFooter>
  <div class="cv-review__footer">
    <span>{{ "cv-review.footer.only-accepted" | translate }}</span>
    <div>
      <button nz-button nzType="default" (click)="onCancel()">{{ "cv-review.action.review-later" | translate }}</button>
      <button nz-button nzType="primary" (click)="onSave()" [disabled]="loading">
        {{ (loading ? "cv-review.action.applying" : "cv-review.action.apply") | translate }}
      </button>
    </div>
  </div>
</ng-container>
